export default "__VITE_ASSET__drNoAdIA__"